// extracted by mini-css-extract-plugin
module.exports = {"root":"ThemeProvider_root__kM0nI"};